import gql from "graphql-tag"

export const DISPLAYED_PRODUCTS_ATTRIBUTES_FRAGMENT = gql`
  fragment GetDisplayedProductsFragment on Product {
    id
    drugType
    drugClass
    drugCategory
    needsPrescription
    supplyInDays
    price
    genericName
    description
    drugFactsPath
    dosageType
    dosageValue
    amountType
    amountValue
    displayedAmount
    displayedDosage
    userSelectable
    recurringProduct {
      id
      price
    }
  }
`

export const GET_DISPLAYED_PRODUCTS_QUERY = gql`
  query GetDisplayedProducts {
    displayedProducts {
      ...GetDisplayedProductsFragment
    }
  }
  ${DISPLAYED_PRODUCTS_ATTRIBUTES_FRAGMENT}
`
